export default "__VITE_ASSET__c1be7778__"